import DiallerPushLogTypes from "./diallerPushLog.types";

export const diallerPushLogFetchStart = (adminUserList: any) => ({
  type: DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_START,
  payload: adminUserList,
});

export const diallerPushLogFetchSuccess = (success: any) => ({
  type: DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_SUCCESS,
  payload: success,
});

export const diallerPushLogFetchFailure = (failure: any) => ({
  type: DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_FAILURE,
  payload: failure,
});

export const diallerPushLogFetchResetStart = () => ({
  type: DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_RESET_START,
});

export const diallerPushLogFetchResponseChanged = () => ({
  type: DiallerPushLogTypes.DIALLER_PUSH_LOG_FETCH_RESPONSE_CHANGED,
});
